import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat.js';
dayjs.extend(customParseFormat);

export const dateFormat = 'DD.MM.YYYY';

export const formatDate = (date) =>
    dayjs.isDayjs(date) ? date.format('DD.MM.YYYY') : dayjs(date).format('DD.MM.YYYY');

export const getUTCDate = (date) =>
    dayjs.isDayjs(date)
        ? date.format('YYYY-MM-DD') + 'T00:00:00.00Z'
        : dayjs(date).format('YYYY-MM-DD') + 'T00:00:00.00Z';

export function normalizeDateOnly(input) {
    if (!input) {
        return null;
    }

    return dayjs(input).format('YYYY-MM-DD');
}

export function disabledBeforeToday(current) {
    return current && current < dayjs().startOf('day');
}

export function disabledBeforeMonth(current) {
    const beforeCurrent = dayjs().subtract(1, 'month').startOf('day');
    return current && current < beforeCurrent;
}

export function disabledAfterHalfAYear(current) {
    const afterCurrent = dayjs().add(6, 'month').startOf('day');
    return current && current > afterCurrent;
}

const isHoliday = (day, holidayKeys) => (holidayKeys.length ? holidayKeys.find((h) => h === formatDate(day)) : false);

export const findNextWorkingDay = (today, holidayKeys) => {
    if (today.day() !== 0 && today.day() !== 6 && !isHoliday(today, holidayKeys)) {
        return today;
    }
    const nextDay = today.add(1, 'day');
    return findNextWorkingDay(nextDay, holidayKeys);
};

export const findNextDayOff = (today, holidayKeys) => {
    if (today.day() === 0 || today.day() === 6 || isHoliday(today, holidayKeys)) {
        return today;
    }
    const nextDay = today.add(1, 'day');
    return findNextDayOff(nextDay, holidayKeys);
};

export const only16YearsOld = (current) => {
    return current && current.year() + 16 > dayjs().year();
};

export function startOfCurrentMonth() {
    return dayjs().date(1);
}
export function endOfCurrentMonth() {
    const daysInMonth = dayjs().daysInMonth();
    return dayjs().date(daysInMonth);
}
